import { UserType } from "@mcleod/core";
import { DataSource } from "@mcleod/components";
import { AutogenLayoutUserTableLocation } from "./autogen/AutogenLayoutUserTableLocation";
import { UserTableController  } from "./UserTableController";
import { UserTableLayout } from "./UserTableLayout";

export class UserTableLocation extends AutogenLayoutUserTableLocation implements UserTableLayout {
    public getSourceUsers(): DataSource {
        return this.sourceUserSettings;
    }

    public getUserType(): UserType {
        return UserType.LOCATION;
    }

    override onLoad(): void | Promise<void> {
        new UserTableController(this);
    }
}
